import { useQuery } from "wasp/client/operations";
import { getGlobalMentorNotes } from "wasp/client/operations";
import MentorNoteEditor from "./MentorNoteEditor";
import useTranslation from "../client/hooks/useTranslation";
import { format } from "date-fns";

interface GlobalNotesTabProps {
  studentId: string;
}

export default function GlobalNotesTab({ studentId }: GlobalNotesTabProps) {
  const t = useTranslation();
  const { data: rawNotes, refetch } = useQuery(getGlobalMentorNotes, { studentId });
  const notes = (rawNotes as any[]) ?? [];

  return (
    <div className="space-y-4 p-4">
      <h3 className="text-sm font-semibold text-foreground">{t.mentor.globalNotes}</h3>

      <MentorNoteEditor
        studentId={studentId}
        isGlobalNote={true}
        onSaved={() => refetch()}
      />

      {notes.length === 0 ? (
        <p className="text-sm text-muted-foreground">{t.mentor.noNotes}</p>
      ) : (
        <div className="space-y-3">
          {notes.map((note) => (
            <div key={note.id} className="space-y-1">
              <p className="text-xs text-muted-foreground">
                {format(new Date(note.createdAt), "dd/MM/yyyy HH:mm")}
              </p>
              <MentorNoteEditor
                studentId={studentId}
                existingNote={{ id: note.id, content: note.content }}
                isGlobalNote={true}
                onSaved={() => refetch()}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
